import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectFilter } from '../slices/filterSlice'

export const useFilter = () => {
  const filter: FilterSliceState = useSelector(selectFilter)
  return useMemo(() => ({ filter }), [filter])
}
